import React from "react";
import { Popover, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

export default function AttachmentPermissionsPopover({ children, canViewOrDownload }) {
  const { t } = useTranslation();

  const hasReadFilePermission = canViewOrDownload;

  if (hasReadFilePermission) {
    return children;
  }
  return (
    <Popover
      trigger="hover"
      content={
        <Space>
          <Text>{t("attachments_disabled")}</Text>
        </Space>
      }
    >
      {children}
    </Popover>
  );
}
